import { render, staticRenderFns } from "./ReferenciasTable.vue?vue&type=template&id=33d9fdbf&scoped=true"
import script from "./ReferenciasTable.vue?vue&type=script&lang=js"
export * from "./ReferenciasTable.vue?vue&type=script&lang=js"
import style0 from "./ReferenciasTable.vue?vue&type=style&index=0&id=33d9fdbf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d9fdbf",
  null
  
)

export default component.exports